@if (componentData$ | async; as data) {
  <div class="custom-align-center">
    <a routerLink="{{data.url}}" class="nav-link secondary-anchor custom-align-center">
      {{data.linkName}}
    </a>
  </div>
}